import { ReactElement } from 'react';
import RawDataOverviewContainer from './OverviewContainer';
import Scatter from '../scatter';
import {
  ParametersType,
  PlotTransformedDataType,
  TimeSpan
} from '../../constants/telosair-interfaces';

type Props = {
  onZoom?: () => void;
  onBackPress?: () => void;
  isZoomed?: boolean;
  selectedDevices: { label: string; value: number }[];
  selectedParameters: ParametersType[];
  graphData: PlotTransformedDataType;
  timeSpan: TimeSpan;
  loading: boolean;
  localParameterList: any[];
};

/**
 * React component for ScatterPlot.
 * @param props - Properties of ScatterPlot component.
 * @returns - React component for ScatterPlot.
 */
export default function ScatterPlot(props: Props): ReactElement {
  const {
    onZoom,
    onBackPress,
    isZoomed,
    selectedParameters,
    selectedDevices,
    graphData,
    timeSpan,
    loading,
    localParameterList
  } = props;
  return (
    <RawDataOverviewContainer
      size={isZoomed ? 'full' : '1/2'}
      onBackPress={onBackPress}
      onZoom={onZoom}
      sectionName="Scatter Plot"
      zoomed={isZoomed}
      loading={loading}
    >
      <Scatter
        isZoomed={isZoomed}
        graphData={graphData}
        localParameterList={localParameterList}
        timeSpan={timeSpan}
        selectedParameters={selectedParameters}
        selectedDevices={selectedDevices}
      />
    </RawDataOverviewContainer>
  );
}
